export default class FrontPageEnum {
    static HEADER_OVERTITLES = '[data-element="header-home-overtitles"]'

    static STRATE_UNMISSABLE_SLIDER = '[data-element="strate-unmissable-slider"]'
    static STRATE_UNMISSABLE_SLIDER_NAVIGATION =
        '[data-element="strate-unmissable-slider-navigation"]'
    static STRATE_UNMISSABLE_SLIDER_NAVIGATION_PREV =
        '[data-element="strate-unmissable-slider-navigation-prev"]'
    static STRATE_UNMISSABLE_SLIDER_NAVIGATION_NEXT =
        '[data-element="strate-unmissable-slider-navigation-next"]'

    static STRATE_STAY_SLIDER = '[data-element="strate-stay-slider"]'
    static STRATE_STAY_SLIDER_NAVIGATION = '[data-element="strate-stay-slider-navigation"]'
    static STRATE_STAY_SLIDER_NAVIGATION_PREV =
        '[data-element="strate-stay-slider-navigation-prev"]'
    static STRATE_STAY_SLIDER_NAVIGATION_NEXT =
        '[data-element="strate-stay-slider-navigation-next"]'

    static STRATE_BLOG_SLIDER = '[data-element="strate-blog-slider"]'
    static STRATE_BLOG_SLIDER_NAVIGATION = '[data-element="strate-blog-slider-navigation"]'
    static STRATE_BLOG_SLIDER_NAVIGATION_PREV =
        '[data-element="strate-blog-slider-navigation-prev"]'
    static STRATE_BLOG_SLIDER_NAVIGATION_NEXT =
        '[data-element="strate-blog-slider-navigation-next"]'

    static STRATE_AGENDA_SLIDER = '[data-element="strate-agenda-slider"]'
    static STRATE_AGENDA_SLIDER_THUMBS = '[data-element="strate-agenda-slider-thumbs"]'
    static STRATE_AGENDA_SLIDER_THUMBS_ITEM = '[data-element="strate-agenda-slider-thumbs-item"]'
    static STRATE_AGENDA_SLIDER_NAVIGATION = '[data-element="strate-agenda-slider-navigation"]'
    static STRATE_AGENDA_SLIDER_NAVIGATION_PREV =
        '[data-element="strate-agenda-slider-navigation-prev"]'
    static STRATE_AGENDA_SLIDER_NAVIGATION_NEXT =
        '[data-element="strate-agenda-slider-navigation-next"]'
    static STRATE_AGENDA_SLIDER_DOTS = '[data-element="strate-agenda-slider-dots"]'

    static STRATE_CITY = '[data-element="strate-city"]'
    static STRATE_CITY_IMAGES = '[data-element="strate-city-images"]'
    static STRATE_CITY_IMAGES_WRAPPER = '[data-element="strate-city-images-wrapper"]'
    static STRATE_CITY_IMAGES_ITEM = '[data-element="strate-city-images-item"]'
    static STRATE_CITY_ITEM = '[data-element="strate-city-item"]'
    static STRATE_CITY_ITEM_CONTENT = '[data-element="strate-city-item-content"]'

    static STRATE_SOCIAL_WALL = '[data-element="social-wall"]'

    static PARALLAX_ITEM = '[data-action="parallax"]'
}
